/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import Axios from 'axios';

/**
 * An http client singleton used by the http service
 * to make api calls.
 */
export const httpClient = Axios.create();
